import { createFileRoute } from '@tanstack/react-router'

import { getUIVersion } from 'lib/uiVersion'

import Project from 'pages/Project'
import ProjectClassic from 'pages/Project/Project.classic'

// Read once at module load -- version never changes without a full page reload
const IS_CLASSIC_UI = getUIVersion() === 'classic'

export const Route = createFileRoute('/_auth/projects/$id/')({
  component: IS_CLASSIC_UI ? ProjectClassic : Project,
})
